import { Button } from "@/components/ui/button";
import { Trash, Clock, Copy } from "@phosphor-icons/react";
import { PricingSimulation } from "../types";
import { Spinner } from "@/components/ui/spinner";

interface SavedSimulationsListProps {
  simulations: PricingSimulation[];
  loading: boolean;
  onLoad: (simulation: PricingSimulation) => void;
  onDuplicate: (simulation: PricingSimulation) => void;
  onDelete: (id: number) => void;
}

export const SavedSimulationsList = ({
  simulations,
  loading,
  onLoad,
  onDuplicate,
  onDelete,
}: SavedSimulationsListProps) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center py-4">
        <Spinner />
      </div>
    );
  }

  if (simulations.length === 0) {
    return (
      <div className="text-center py-4 text-neutral-secondary-mid text-xs">
        Nog geen opgeslagen simulaties.
      </div>
    );
  }

  return (
    <div className="space-y-1">
      {simulations.map((sim) => (
        <div
          key={sim.id}
          className="flex items-center gap-2 p-2 rounded-md hover:bg-muted/50 cursor-pointer transition-colors group"
          onClick={() => onLoad(sim)}
        >
          <div className="min-w-0 flex-1">
            <p className="font-medium text-xs truncate">{sim.name}</p>
            <div className="flex items-center gap-1">
              <Clock size={9} className="text-neutral-secondary-mid" />
              <span className="text-[9px] text-neutral-secondary-mid">
                {sim.createdByUserName && `${sim.createdByUserName} \u00B7 `}
                {sim.updatedAt
                  ? new Date(sim.updatedAt).toLocaleDateString("nl-BE", {
                      day: "numeric",
                      month: "short",
                      hour: "2-digit",
                      minute: "2-digit",
                    })
                  : ""}
              </span>
            </div>
          </div>
          <div className="flex items-center gap-0.5 opacity-0 group-hover:opacity-100 transition-opacity">
            <Button
              variant="ghost"
              size="sm"
              className="h-6 w-6 p-0 text-neutral-secondary-mid hover:text-primary"
              title="Kopieer simulatie"
              onClick={(e) => {
                e.stopPropagation();
                onDuplicate(sim);
              }}
            >
              <Copy size={12} />
            </Button>
            <Button
              variant="ghost"
              size="sm"
              className="h-6 w-6 p-0 text-neutral-secondary-mid hover:text-destructive"
              title="Verwijder"
              onClick={(e) => {
                e.stopPropagation();
                if (sim.id) onDelete(sim.id);
              }}
            >
              <Trash size={12} />
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
};
